export default __webpack_public_path__ + "static/client-3-011d68ed0e27a9960a823a62bd5f0bcd.jpg";